import type { FirmDomain } from "@/shared/utils/firm";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface HardcodedParams {
  // Add future per-firm feature flags here
}

/**
 * Per-firm feature flags.
 * `useHardcodedParams()` always returns a fully-typed, non-undefined value.
 */
export const HARDCODED_PARAMS: Record<FirmDomain, HardcodedParams> = {
  hourglass: {},
  pregodonnell: {},
  tysonmendes: {},
  bpmlaw: {},
  taylorday: {},
  namanhowell: {},
  gouldratner: {},
  unknown: {},
};
